import { Box, Stack } from "@mui/material";
import { FC } from "react";
import { ECompanyContractStatus } from "@/types/enum";
import { CompanyListTop } from "@/features/company/components/CompanyListTop";
import { CompanyTable } from "@/features/company/components/CompanyTable";

type TTrialCancelledCompanyListPageProps = {};

const contractStatuses = [ECompanyContractStatus.TRIAL_CANCELLED];

export const TrialCancelledCompanyListPage: FC<TTrialCancelledCompanyListPageProps> = () => {
  return (
    <Box>
      <Stack gap={3}>
        <CompanyListTop contractStatuses={contractStatuses} />
        <CompanyTable contractStatuses={contractStatuses} />
      </Stack>
    </Box>
  );
};
